import PropTypes from "prop-types";
import "./styles.css";

export default function WalletIcon({ sx }) {
	return (
		<svg id="Layer_2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.88 50.5" style={sx}>
			<g id="Layer_1-2">
				<path
					className="wallet-icon-component"
					d="M43.15,8.2c-1.42-3.37-5.3-5.33-9.06-4.06l-10.52,3.57h10.51c2.73,0,4.89,0,6.64.14.87.07,1.67.18,2.42.35ZM47.44,
					10.33c-.45-7.17-7.63-12.09-14.56-9.74l-22.94,7.78s-.07.03-.11.04c-.51.16-1,.35-1.48.59-2.23,1.14-4.05,2.96-5.19,
					5.19-.7,1.38-1.01,2.89-1.15,4.67-.14,1.74-.14,3.91-.14,6.64v6.71c-1.19,1.85-1.88,4.06-1.88,6.41,0,2.22.62,4.33,
					1.72,6.12.6,1.02,1.37,1.94,2.26,2.71,2.08,1.89,4.85,3.05,7.9,3.05,2.47,0,4.76-.75,6.65-2.04h15.56c2.73,0,4.89,0,
					6.64-.14,1.78-.15,3.29-.45,4.67-1.15,2.23-1.14,4.05-2.96,5.19-5.19.7-1.38,1.01-2.89,1.15-4.67.14-1.74.14-3.91.14-6.64v-5.17c0-2.73,
					0-4.89-.14-6.64-.15-1.78-.45-3.29-1.15-4.67-.77-1.5-1.84-2.82-3.14-3.86ZM22.05,44.71h11.95c2.83,0,4.84,0,6.42-.13,1.55-.13,2.51-.37,3.27-.76,
					1.53-.78,2.77-2.02,3.55-3.55.39-.76.63-1.72.76-3.27.13-1.57.13-3.58.13-6.42v-5c0-2.83,
					0-4.84-.13-6.42-.13-1.55-.37-2.51-.76-3.27-.78-1.53-2.02-2.77-3.55-3.55-.76-.39-1.72-.63-3.27-.76-1.57-.13-3.58-.13-6.42-.13h-14.25c-2.83,
					0-4.84,0-6.42.13-1.55.13-2.51.37-3.27.76-1.53.78-2.77,2.02-3.55,3.55-.39.76-.63,1.72-.76,3.27-.13,1.57-.13,3.58-.13,6.42v2.93c1.82-1.13,
					3.97-1.77,6.25-1.77,3.49,0,6.67,1.51,8.83,3.95,1.89,2.1,3.05,4.89,3.05,7.92,0,.95-.12,1.87-.35,2.77-.27,1.17-.73,2.31-1.35,3.32ZM5.59,
					33.47h.04v-.05c.13-.16.27-.32.42-.47M5.59,33.47c-1.15,1.4-1.84,3.21-1.84,5.16,0,1.52.43,2.96,1.17,4.17l.02.03c.39.67.91,1.29,1.51,
					1.81l.04.03c1.42,1.3,3.3,2.08,5.39,2.08,2.96,0,5.54-1.58,6.94-3.93l.02-.03c.42-.67.74-1.45.92-2.25,0-.02.01-.05.02-.07.16-.59.24-1.2.24-1.84,
					0-2.07-.79-3.97-2.09-5.42l-.02-.02c-1.45-1.65-3.61-2.69-6.02-2.69-2.28,0-4.35.93-5.83,2.46M34.79,25.09c-.84,0-1.6.34-2.15.91-.52.54-.84,
					1.28-.84,2.09,0,.56.16,1.09.43,1.52l.02.03c.14.23.32.45.54.64l.04.03c.52.47,1.2.76,1.97.76,1.09,0,2.04-.58,
					2.55-1.44l.02-.03c.15-.24.26-.52.33-.8,0-.02.01-.05.02-.07.05-.2.08-.42.08-.65,0-.76-.29-1.46-.77-1.99l-.02-.02c-.52-.6-1.32-.98-2.21-.98ZM29.95,
					23.38c1.23-1.26,2.95-2.04,4.84-2.04,1.98,0,3.79.85,5.02,2.25,1.07,1.19,1.73,2.77,1.73,4.5,0,.54-.07,1.06-.2,1.58-.16.67-.42,1.32-.78,1.9-1.17,
					1.95-3.31,3.26-5.77,3.26-1.73,0-3.3-.65-4.48-1.73-.5-.44-.94-.96-1.28-1.54-.62-1.02-.97-2.22-.97-3.48,0-1.82.73-3.49,1.91-4.7ZM16.91,
					34.82c.73.73.73,1.92,0,2.65l-5,5c-.73.73-1.92.73-2.65,0l-2.5-2.5c-.73-.73-.73-1.92,0-2.65.73-.73,1.92-.73,2.65,0l1.17,1.17,3.67-3.67c.73-.73,1.92-.73,2.65,0Z"
				/>
			</g>
		</svg>
	);
}
WalletIcon.propTypes = {
	sx: PropTypes.object,
};
